import importerStore from '@shared/importer/importer-store';
import { SeasonService } from '@modules/season/season-service';
import seasonImporterFields from '@modules/season/season-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  SeasonService.import,
  seasonImporterFields,
  i18n('entities.season.importer.fileName'),
  i18n('entities.season.importer.hint'),
);
